/**
 * HomeTrustBar — Black full-width strip with 4 trust pillars.
 * Maps to the Trust Bar section in index.html.
 * Design tokens: ds-inverse-surface (bg), ds-on-primary (white text),
 * ds-primary (divider tint), inter (body).
 * Uses react-icons (already installed) — NOT Material Symbols.
 */
import { FaHeadset, FaShieldAlt, FaTruck, FaUndo } from "react-icons/fa";

const PILLARS = [
  { Icon: FaShieldAlt, label: "100% Genuine Products" },
  { Icon: FaTruck, label: "Fast Local Delivery" },
  { Icon: FaUndo, label: "Easy 30-Day Returns" },
  { Icon: FaHeadset, label: "Expert Rider Support" },
];

const HomeTrustBar = () => (
  <section
    className="w-full bg-ds-inverse-surface h-[72px] flex items-center justify-center"
    aria-label="Trust guarantees"
  >
    <div className="max-w-[1280px] w-full flex items-center justify-around px-4">
      {PILLARS.map(({ Icon, label }, idx) => (
        <div key={label} className="flex items-center">
          {idx > 0 && (
            <div
              className="hidden sm:block h-5 w-px bg-ds-primary/30 mr-4 md:mr-8"
              aria-hidden="true"
            />
          )}
          <div className="flex items-center gap-2 text-white">
            <Icon className="text-[18px] shrink-0" aria-hidden="true" />
            <span className="font-inter font-medium text-[13px] whitespace-nowrap">
              {label}
            </span>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default HomeTrustBar;
